













































import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus, LadingStatus} from "@/enums/status";
import {FreightServiceType, LadingType} from "@/enums/type";
import {assignValueToForm, getValuesEnum} from "@/shared/services/helper/utils";
import {LadingStore} from "@/modules/ladings/store";
import debounce from "lodash/debounce";
import {LadingParams} from "@/modules/ladings/params";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import { difference } from 'lodash';
import PostOfficeForm from "@/modules/postoffices/Form/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import LadingCustomerStatusSelector from "@/shared/components/LadingCustomerStatusSelector/index.vue";

@Component({
    name: "LadingSearch",
    components: {
        LadingCustomerStatusSelector,
      PostOfficeSelector,
      PostOfficeForm, FreightServiceSelector, MillisecondDatePicker, ProvinceSelector, EnumSelector}
})
export default class extends Vue {
    LadingStatus = LadingStatus;
    LadingType = LadingType;
    FreightServiceType = FreightServiceType;
    exceptStatus = [
        LadingStatus.GdKhoiTao,
        LadingStatus.LayHangThanhCong,
        LadingStatus.LayHangThanhCongChoCapNhat,
        LadingStatus.ChoLayHang,
        LadingStatus.ChoCapNhat
    ];

    get form() {
        return LadingStore.params;
    }
    set form(data: any) {
        LadingStore.updateLadingParams(data);
    }

    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        LadingStore.updateLadingParams(val);
        LadingStore.listLading({ ...LadingStore.params, page: 1 })
    }, 500);
}
